var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeaderDownarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_7",
    "data-name": "Polygon 7",
    d: "M4,0,8,6H0Z",
    transform: "translate(8 6) rotate(180)",
    fill: "#231f20"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderDownarrow);
export default __webpack_public_path__ + "static/media/header-downarrow.c3de273ca7c457b1d35f0915b843d016.svg";
export { ForwardRef as ReactComponent };